export { default } from './NtaHeader';
export { NTA_HEADER_TITLES, NTA_HEADER_VARIANT } from '../../constants';
